var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#191E1E",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 7.6V16a1.396 1.396 0 0 1-1.4 1.4H7c-.387 0-.737-.157-.99-.41A1.396 1.396 0 0 1 5.6 16V7.6h8.8Zm1-.2V6c0-.387-.157-.737-.41-.99A1.396 1.396 0 0 0 14 4.6H6A1.396 1.396 0 0 0 4.6 6v1.4h10.8Zm-3-3c0-.787-.157-1.137-.41-1.39A1.396 1.396 0 0 0 11 2.6H9A1.396 1.396 0 0 0 7.6 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M7.5 15.5v-6m2.5 6v-6m2.5 6v-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b812eba912db78550fb7306525894458.svg";
export { ForwardRef as ReactComponent };